import React from 'react';
import styled, { css } from 'styled-components';

import { DarkModeContext } from './context/DarkModeContext';
import { COLORS } from './common/constants';

const DarkModeToggle = () => {
	const { toggleDarkMode, isDarkModeOn } = React.useContext(DarkModeContext);
	return <Button onClick={toggleDarkMode} isDarkModeOn={isDarkModeOn}></Button>;
};

export default DarkModeToggle;

// 🎨 Styled Components
const Button = styled.input.attrs({
	type: 'checkbox'
})`
	position: relative;
	-webkit-appearance: none;
	height: 30px;
	width: 50px;
	border-radius: 30px;
	cursor: pointer;
	outline: none;
	border: 4px solid ${COLORS.mainBlue};
	box-sizing: content-box;
	box-shadow: 0 0.25rem 0.5rem 0 rgba(0, 0, 0, 0.08);

	${(props) =>
		props.isDarkModeOn &&
		css`
			background: transparent;
			border: 4px solid ${COLORS.mainAqua};
		`}

	&:before {
		position: absolute;
		top: 4px;
		left: 5px;
		content: '';
		height: 14px;
		width: 14px;
		border: 4px solid ${COLORS.mainBlue};
		border-radius: 50%;
		transition: 0.3s;
		box-shadow: 0 0.25rem 0.5rem 0 rgba(0, 0, 0, 0.08);
		${(props) =>
			props.isDarkModeOn &&
			css`
				width: 0;
				left: 34px;
				border-radius: 5px;
				border: 3px solid ${COLORS.mainAqua};
			`}
	}
`;
